import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Solicitação', flex: 1.5, orderValue: 'requestDate' },
  { title: 'Tipo', flex: 1, orderValue: 'movementType' },
  { title: 'Cliente', flex: 1.5, orderValue: 'clientName' },
  { title: 'Ativo', flex: 1.5, orderValue: 'productName' },
  { title: 'Vencimento', flex: 1, orderValue: 'maturityDate' },
  { title: 'Valor', flex: 1, orderValue: 'movementValue' },
  { title: 'Status', flex: 1, orderValue: 'status' },
];
